import TechnicalKnowledge from "./technical-knwoledge";

export default TechnicalKnowledge;
